let dialogInstance = null

export function setDialogInstance(instance) {
  dialogInstance = instance
}

export function alert(message, options = {}) {
  return new Promise((resolve) => {
    if (!dialogInstance) {
      window.alert(message)
      resolve()
      return
    }

    const {
      title = '提示',
      icon = 'info',
      confirmText = '确定',
      confirmType = 'primary'
    } = options

    dialogInstance.showDialog({
      visible: true,
      title,
      message,
      icon,
      showCancel: false,
      confirmText,
      confirmType,
      onConfirm: () => {
        dialogInstance.hideDialog()
        resolve()
      }
    })
  })
}

export function confirm(message, options = {}) {
  return new Promise((resolve, reject) => {
    if (!dialogInstance) {
      const result = window.confirm(message)
      if (result) {
        resolve()
      } else {
        reject()
      }
      return
    }

    const {
      title = '确认',
      icon = 'warning',
      cancelText = '取消',
      confirmText = '确定',
      confirmType = 'primary'
    } = options

    dialogInstance.showDialog({
      visible: true,
      title,
      message,
      icon,
      showCancel: true,
      cancelText,
      confirmText,
      confirmType,
      onConfirm: () => {
        dialogInstance.hideDialog()
        resolve()
      },
      onCancel: () => {
        dialogInstance.hideDialog()
        reject()
      }
    })
  })
}

export function success(message, options = {}) {
  return alert(message, {
    title: '成功',
    icon: 'success',
    confirmType: 'success',
    ...options
  })
}

export function error(message, options = {}) {
  return alert(message, {
    title: '错误',
    icon: 'error',
    confirmType: 'danger',
    ...options
  })
}

export function warning(message, options = {}) {
  return alert(message, {
    title: '警告',
    icon: 'warning',
    ...options
  })
}

export default {
  alert,
  confirm,
  success,
  error,
  warning,
  setDialogInstance
}
